<template>
  <div>
    <stepper
      role="region"
      aria-label="Graficzne przedstawienie kroków rejestracji"
      :active-step="activeStep"
      :steps="steps"
      @change="setStep"
    />

    <stepper-step :active-step="activeStep" :step="0">
      <v-card-text class="elevation-0 mb-3 error-top">
        <w-input append-icon="mail" name="login" placeholder="kowalski@poczta.pl" outlined :model="schema.login" />

        <div class="input-description font-medium" role="region" aria-labelledby="info">
          <span id="info"> <v-icon class="mr-2 lighten-2">info</v-icon>Hasło ustalisz po potwierdzeniu konta. </span>
        </div>
      </v-card-text>
    </stepper-step>

    <stepper-step :active-step="activeStep" :step="1">
      <v-card-text class="elevation-0 mb-3 error-top">
        <w-input append-icon="mdi-account" name="name" placeholder="Jan" outlined :model="schema.profile.firstName" />

        <w-input
          append-icon="mdi-account"
          name="surname"
          placeholder="Kowalski"
          outlined
          :model="schema.profile.lastName"
        />

        <w-date-picker
          append-icon="mdi-calendar"
          name="date"
          placeholder="01.01.1990"
          outlined
          start-picker="year"
          :model="schema.profile.birthDate"
        />

        <w-select
          append-icon="mdi-account"
          name="gender"
          outlined
          item-text="text"
          item-value="value"
          :items="gender"
          :model="schema.profile.gender"
        />

        <w-input
          append-icon="mdi-phone"
          name="phone"
          placeholder="888 888 888"
          outlined
          :model="schema.profile.phoneNumber"
        />
      </v-card-text>

      <v-card-text class="elevation-0 mb-3 error-top">
        <teryt-form :schema="schema.profile" />

        <div v-if="schema.profile.simc.$value">
          <w-input placeholder="--" outlined :model="schema.profile.homeNumber" />

          <w-input placeholder="--" outlined :model="schema.profile.localNumber" />
        </div>
      </v-card-text>
    </stepper-step>

    <stepper-step :active-step="activeStep" :step="2">
      <consents-input :model="schema.terms" :terms-list="termsList" />
    </stepper-step>

    <div role="region" aria-label="Przyciski funkcyjne">
      <v-card-actions class="split-buttons">
        <v-btn v-if="activeStep === 0" large outlined elevation="0" color="primary" :to="{ name: 'login' }">
          Anuluj
        </v-btn>

        <v-btn v-else large outlined elevation="0" color="primary" @click="previousStep">Cofnij</v-btn>

        <v-btn v-if="activeStep < 2" large elevation="0" color="primary" @click="nextStep">Dalej</v-btn>

        <v-btn v-else large elevation="0" color="primary" @click="registerAccount">Zarejestruj się</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import { WInput, WSelect, WDatePicker } from '@witkac/vuetify-components';
import { Gender, GenderTranslation } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import TerytForm from '@/components/forms/TERYTForm';
import { loginRoute } from '@/router/start/login.route';
import Stepper from '@/components/material/Stepper';
import StepperStep from '@/components/material/StepperStep';
import ConsentsInput from '@/components/forms/ConsentsInput';
import { stepperMixin } from '@/mixins/stepperMixin';

// @vuese
// Formularz rejestracji
// @group Forms
export default {
  components: { ConsentsInput, WInput, WSelect, WDatePicker, TerytForm, Stepper, StepperStep },
  mixins: [stepperMixin],
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loginPath: loginRoute.path,
      activeStep: 0,
      steps: ['Dane logowania', 'Dane osobowe', 'Formalności'],
      gender: [
        { text: GenderTranslation[Gender.FEMALE], value: Gender.FEMALE },
        { text: GenderTranslation[Gender.MALE], value: Gender.MALE }
      ]
    };
  },
  computed: mapState({ termsList: state => state.terms.current, profileByEmail: state => state }),

  methods: {
    // @vuese
    // Rejestracja w "registerAccount" => register.vue
    registerAccount() {
      this.$emit('registerAccount');
    },
    // @vuese
    // Przejście do kolejnego kroku
    nextStep() {
      if (this.activeStep === 0) {
        this.$store.dispatch('auth/checkLoginAvailability', this.schema.login.$model).then(available => {
          this.schema.loginAvailable.$setData(available);
          this.setStep(this.activeStep + 1);
        });
      } else {
        this.setStep(this.activeStep + 1);
      }
    },
    // @vuese
    // Przejście do poprzedniego kroku
    previousStep() {
      this.setStep(this.activeStep - 1);
    }
  }
};
</script>
